var Ajaxinate = function(e) {
  var t = {
    container: "#AjaxinateContainer",
    pagination: "#AjaxinatePagination",
    method: "scroll",
    offset: 0
  };
  this.settings = Object.assign(t, e);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function() {
  if (!this.containerElement) return;
  if (!this.paginationElement) return;
  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  if (!this.nextPageLinkElement) return;
  this.nextPageUrl = this.nextPageLinkElement.href;
  if (this.settings.method === "click") {
    this.nextPageLinkElement.addEventListener("click", this.handleClick.bind(this));
  } else {
    this.checkIfPaginationInView();
    document.addEventListener("scroll", this.checkIfPaginationInView.bind(this));
  }
};

Ajaxinate.prototype.handleClick = function(e) {
  e.preventDefault();
  this.nextPageLinkElement.innerText = "Loading...";
  this.loadMore();
};

Ajaxinate.prototype.checkIfPaginationInView = function() {
  var e = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  e <= window.innerHeight && this.loadMore();
};

Ajaxinate.prototype.loadMore = function() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var e = this.request.responseXML.querySelector(this.settings.container);
      var t = this.request.responseXML.querySelector(this.settings.pagination);
      this.containerElement.insertAdjacentHTML("beforeend", e.innerHTML);
      if (t && t.querySelector("a")) {
        this.nextPageLinkElement.href = t.querySelector("a").href;
        this.nextPageLinkElement.innerText = "Load More";
        this.nextPageUrl = this.nextPageLinkElement.href;
      } else {
        this.paginationElement.style.display = "none";
      }
    }
  }.bind(this);
  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};